


























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import GeneralInfo from '@/components/form/GeneralInfo.vue';
import Contact from '@/components/form/Contact.vue';
import Hours from '@/components/form/Hours.vue';
import { Validation } from 'vuelidate';

@Component({
	components: {
		GeneralInfo,
		Contact,
		Hours
	}
})
export default class LocationTabs extends Vue {
	tab: number | null = null;
	isMounted = false;

	get sliderColor() {
		const error = '#D41A27';
		const valid = '#1976D2';
		let color = valid;
		switch (this.tab) {
			case 0:
				if (this.generalInfoError == true) {
					color = error;
				}
				break;
			case 1:
				if (this.contactError == true) {
					color = error;
				}
				break;
			case 2:
				if (this.hoursError == true) {
					color = error;
				}
				break;
			default:
				break;
		}
		return color;
	}

	mounted() {
		this.isMounted = true;
	}

	touch(): void {
		(this.$refs.hours as Vue  & { $v: Validation})?.$v.$touch();
		(this.$refs.contact as Vue  & { $v: Validation}).$v.$touch();
		(this.$refs.generalInfo as Vue  & { $v: Validation}).$v.$touch();
	}

	reset(): void {
		(this.$refs.hours as Vue  & { $v: Validation}).$v.$reset();
		(this.$refs.contact as Vue  & { $v: Validation}).$v.$reset();
		(this.$refs.generalInfo as Vue  & { $v: Validation}).$v.$reset();
	}

	get isDirty(): boolean {
		return (this.$refs.hours as Vue  & { $v: Validation}).$v.$anyDirty ||
			(this.$refs.contact as Vue  & { $v: Validation}).$v.$anyDirty ||
			(this.$refs.generalInfo as Vue  & { $v: Validation}).$v.$anyDirty;
	}

	get hasErrors(): boolean {
		if (!this.isMounted) {
			return false;
		}

		return this.hoursError || this.contactError || this. generalInfoError;
	}

	get hoursError(): boolean {
		return this.isMounted && (this.$refs.hours as Vue & { $v: Validation})?.$v?.$anyError;
	}
	get contactError(): boolean {
		return this.isMounted && (this.$refs.contact as Vue & { $v: Validation}).$v.$invalid;
	}
	get generalInfoError(): boolean {
		return this.isMounted && (this.$refs.generalInfo as Vue & { $v: Validation}).$v.$anyError;
	}
}
